// LX's source-preserving relevance order, applied to one response page only.
// Platform IDs remain intact; ordering never creates library membership.
export function editDistance(a: string, b: string) {
  let previous = Array.from({length:b.length + 1}, (_, i) => i);
  for (let i = 1; i <= a.length; i++) {
    const current = [i];
    for (let j = 1; j <= b.length; j++) current[j] = Math.min(current[j - 1] + 1, previous[j] + 1, previous[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
    previous = current;
  }
  return previous[b.length];
}
type SearchTrack = {title: string; artists: string[]; album?: string};
export function rankOnlinePage<T extends SearchTrack>(tracks: T[], query: string, platform: string) {
  if (platform !== 'all') return tracks;
  return tracks.map((track, index) => {const text=track.title + ' ' + track.artists.join(' ');return {track,index,score:editDistance(query,text)/Math.max(1,query.length,text.length)};}).sort((a,b)=>a.score-b.score || a.index-b.index).map(item=>item.track);
}
export function rankLibrary<T extends SearchTrack>(tracks: T[], query: string) {
  const q = query.trim().toLocaleLowerCase();
  if (!q) return [];
  const orderedMatch = (text: string) => {let at=0; for(const char of q){at=text.indexOf(char,at);if(at<0)return false;at++;}return true;};
  return tracks.map((track,index)=>{
    const title=track.title.toLocaleLowerCase(),artist=track.artists.join(' ').toLocaleLowerCase(),album=(track.album || '').toLocaleLowerCase();
    const tier=title===q?0:title.includes(q)?1:artist.includes(q)?2:album.includes(q)?3:orderedMatch(title+' '+artist+' '+album)?4:Infinity;
    return {track,index,tier,distance:tier===4?editDistance(q,title):0};
  }).filter(item=>Number.isFinite(item.tier)).sort((a,b)=>a.tier-b.tier || a.distance-b.distance || a.index-b.index).map(item=>item.track);
}
